<template>
  <div id="taylor">
    
  </div>
</template>

<script>
import functionPlot from "function-plot"

export default {
  data() {
    return {
      
    }
  },
  mounted() {
    functionPlot({
        target: "#taylor",
        width: 500,
        height: 300,
        yAxis: {
            domain: [-5, 5]
        },
        tip: {
            renderer: function (e) {return e }
        },
        grid: true,
      data: [
        {
                fn: "x^2",
                derivative: {
                    fn: "2 * x",
                    updateOnMouseMove: true
                }
            },{
                fn: "sin(x)",
            },{
                fn: "x - 1/6 * x^3",
            },
            {
                fn: "tan(x)",
            }
        ]
    });
  }
}
</script>

<style>

</style>